import { Plan } from 'interfaces/entities/plan.interface';
import { Button, Card, CardContent } from '@mui/material';
import { toCurrencyFormat } from 'helpers/utils';
import { useTranslation } from 'react-i18next';
import { FaInfinity } from 'react-icons/fa';

interface PlanCardProps {
    plan: Plan;
    subscribe: () => void;
    unsubscribe: () => void;
    isSubscribed: boolean;
    // Есть, когда последнее автосписание не прошло (подписка PAST_DUE)
    updateCard?: () => void;
}

export const PlanCard = ({ plan, subscribe, unsubscribe, isSubscribed, updateCard }: PlanCardProps) => {
    const { t } = useTranslation();
    return (
        <div className="h-full">
            <Card sx={{ height: '100%', position: 'relative' }}>
                <CardContent>
                    <div className='plan-item flex flex-col gap-4'>
                        <section className="plan-header flex flex-col gap-2">
                            <div className='mb-2'>
                                <div className="text-lg font-bold">{plan.name}</div>
                            </div>
                            <div className='mb-4'>
                                <div className="text-sm">{plan.description}</div>
                            </div>
                            <div className="flex items-center gap-2 mb-4">
                                <div className="text-2xl font-bold">{toCurrencyFormat(plan.price, plan.currency)}</div>
                                <div>/</div>
                                <div className="text-sm">в месяц</div>
                            </div>
                            <div>
                                {isSubscribed === true ?
                                    (
                                        <div className="flex flex-col gap-2">
                                            <Button fullWidth variant="outlined" color="success" onClick={() => { }}>Ваш текущий тариф</Button>
                                            {updateCard && <Button fullWidth variant="contained" color="warning" onClick={updateCard}>Обновить карту</Button>}
                                            <Button fullWidth variant="outlined" color="error" onClick={unsubscribe}>Отменить подписку</Button>
                                        </div>
                                    ) :
                                    <Button fullWidth variant="outlined" color="primary" onClick={subscribe}>Подключить сейчас</Button>}
                            </div>
                        </section>
                        <section className="plan-features flex flex-col gap-2 mt-4">
                            <ul className="list-none flex flex-col gap-2">
                                {plan.features?.map((feature: any) => (
                                    <li key={feature.id} className="flex items-center gap-2 justify-between">
                                        <div className="text-sm font-medium">{feature.name}</div>
                                        <div className="text-sm flex items-center gap-2">
                                            <span>{feature.PlanFeature?.limit ? String(feature.PlanFeature?.limit) : <FaInfinity size={16} />}</span>
                                            {feature.unit && <span>{t(`units.${feature?.unit}`)}</span>}
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </section>
                    </div>
                </CardContent >
            </Card >
        </div >
    )
}

export default PlanCard;